import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import translationEN from "./locales/en/translation.json";
import translationSV from "./locales/sv/translation.json";

const resources = {
  en: { translation: translationEN },
  sv: { translation: translationSV }
};

// Preserve saved preferences; the public reference starts in Swedish.
const savedLanguage = localStorage.getItem("appLanguage") || "sv";

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage,
    fallbackLng: "en",  // 🔹 fallback English
    interpolation: { escapeValue: false }
  });

export default i18n;
